module.exports = __webpack_public_path__ + "static/media/Nota Comienza a sentirte mejor.807130a8.webp";